import Cookies from 'js-cookie'
import iView from 'iview'
import Vue from 'vue'
Vue.use(iView)

const app = {
  state: {
    clientWidth: 0,
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      minOpen: false // 小屏时菜单状态
    },
    router: {
      currentPageName: 'index'
    },
    lang: {
      icon: '#icon-zhongguo',
      type: 'CN'
    },
    searchState: {
      show: false,
      params: ''
    },
    user: {
      userInfo: null,
      verifyToken: null,
      controlUserInfo:null,
      controlVerifyToken:null
    },
    logo: '',
    deviceStatus:null,
    activeType:null,
    activationType:null,
    deviceType:null
  },
  mutations: {
    setClientWidth(state, currentValue) {
      state.clientWidth = currentValue;
      // console.log(currentValue)
    },
    /**
     * 设置logo
     */
    SET_LOGO : (state,payload) => {
        state.logo = payload;
    },
    /**
     * 菜单的缩展
     */
    TOGGLE_SIDEBAR: state => {
      let winWidth = document.documentElement.clientWidth
      if (winWidth <= 600) {
        state.sidebar.minOpen = !state.sidebar.minOpen
        state.sidebar.opened = false
        Cookies.set('sidebarStatus', 0)
        return
      } else {
        if (state.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
        state.sidebar.opened = !state.sidebar.opened
      }
    },
    CLOSE_SLIDEBAR: state => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.minOpen = false
    },
    OPEN_SLIDEBAR: state => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = true
    },
    /**
     * 面包屑
     */
    GET_CURRENT_PAGE_NAME: (state, payload) => {
      state.router.currentPageName = payload
    },
    /**
     * 面包屑获得当前模块名称
     */
     GET_CURRENT_PAGE_MODULE: (state, payload) => {
        Cookies.set('moduleName',payload);
     },
    /**
     * 获取设备状态
     */
    GET_DEVICE_STATUS: (state, payload) => {
      state.deviceStatus = payload;
    },
    /**
     * 获取设备活动状态
     */
    GET_ACTIVE_STATUS: (state,payload) =>{
      state.activeType = payload;
    },
    /**
     * 获取设备激活状态
     */
    GET_ACTIVATION_STATUS: (state,payload) =>{
      state.activationType = payload;
    },
    /**
     * 获取选择设备类型
     */
    GET_DEVICE_TYPE: (state,payload) =>{
      state.deviceType = payload;
    },

    /**
     * 设置语言
     */
    SET_LANG: (state, payload) => {
      state.lang = payload
      Cookies.set('lang', payload)
    },
    // 设置过期时间为 8小时
    SET_USERID_TOKEN: (state,payload) => {
      Cookies.set('utn', payload.token, {expires: 1 / 3}); //设置token
      Cookies.set('uid', payload.userId, {expires: 1 / 3}); //设置用户id，
    },
    // 设置过期时间为 30天
    SET_USERID_TOKEN_30: (state,payload) => {
      Cookies.set('utn', payload.token, {expires: 30}); //设置token
      Cookies.set('uid', payload.userId, {expires: 30}); //设置用户id，
    },
    CLEAR_USERID_TOKEN: (state) => {
      Cookies.set('utn', ""); //清除token
      Cookies.set('uid', ""); //清除用户id，
    },
    SET_VERYFYTOKEN: (state, verifyToken) => {
      state.user.verifyToken = verifyToken;
    },
    SET_USER_INFO: (state,userInfo) => {
      state.user.userInfo = userInfo;
    },
    SET_AVATAR: (state,avatar) => {
      state.user.userInfo.avator = avatar;
    },
    CONTROL_SET_USERID_TOKEN: (state,payload) => {
      Cookies.set('cutn', payload.token, {expires: 1 / 3}); //设置token
      Cookies.set('cuid', payload.userId, {expires: 1 / 3}); //设置用户id，
    },
    CONTROL_CLEAR_USERID_TOKEN: (state) => {
      Cookies.set('cutn', ""); //清除token
      Cookies.set('cuid', ""); //清除用户id，
    },
    CONTROL_SET_VERYFYTOKEN: (state, verifyToken) => {
      state.user.ControlVerifyToken = verifyToken;
    },
    CONTROL_SET_USER_INFO: (state,userInfo) => {
      state.user.controlUserInfo = userInfo;
    },
    CONTROL_SET_AVATAR: (state,avatar) => {
      state.user.controlUserInfo.avator = avatar;
    }
  },
  actions: {
    ToggleSideBar: ({commit}) => {
      commit('TOGGLE_SIDEBAR')
    },
    getCurrentPageName: ({commit}, payload) => {
      commit('GET_CURRENT_PAGE_NAME', payload)
    },
    setLang: ({commit}, payload) => {
      commit('SET_LANG', payload)
    },
    setUserInfo: ({commit},payload) => {
      commit('SET_USER_INFO', payload)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js